import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ProfileNotesSectionWithCheckbox from '/component/partial/profile/ProfileNotesSectionWithCheckbox';
import {withTranslation} from '/provider/TranslationProvider';
import {
  clientDetailsById,
  notesById,
  notesUpdatedTsById,
  phoneNumberById,
} from '/redux/selector/candidate.selector';
import {withHOC} from '/util/hoc.util';

export default withHOC(
  connect(
    createStructuredSelector({
      notes: notesById,
      notesUpdatedTs: notesUpdatedTsById,
      clientDetails: clientDetailsById,
      phoneNumber: phoneNumberById,
    }),
  ),
  withTranslation('screen.candidateProfile.section.notes'),
)(ProfileNotesSectionWithCheckbox);
